import {Drawer} from 'antd'
import useTranslate from 'modules/local/useTranslate'
import React, {useRef, useState} from 'react'

export const DrawerBottomDialog = ({
                                       placement = 'bottom',
                                       title = '',
                                       isToggle,
                                       toggle,
                                       children,
                                       ...props
                                   }) => {
    const t = useTranslate()
    const [height, setHeight] = useState('auto')
    const [dragY, setDragY] = useState(0)          // độ lệch khi đang kéo
    const [isDismissing, setIsDismissing] = useState(false)

    const touchStartY = useRef(null)
    const touchStartTime = useRef(null)
    const drawerBodyRef = useRef(null)

    const onToggleHeight = () => {
        setHeight(h => h === 'auto' ? '80vh' : 'auto')
    }

    const onClose = () => toggle(false)

    // ── Dismiss với animation ────────────────────────────────────
    const dismissWithAnimation = () => {
        setIsDismissing(true)
        // Đợi animation xong rồi mới close thật
        setTimeout(() => {
            setIsDismissing(false)
            setDragY(0)
            onClose()
        }, 300)
    }
    // ────────────────────────────────────────────────────────────

    const handleTouchStart = (e) => {
        touchStartY.current = e.touches[0].clientY
        touchStartTime.current = Date.now();
        setDragY(0)
    }

    const handleTouchMove = (e) => {
        if (touchStartY.current === null) return;
        const deltaY = e.touches[0].clientY - touchStartY.current
        // Chỉ cho kéo xuống, không cho kéo lên
        if (deltaY > 0) setDragY(deltaY)
    }

    const handleTouchEnd = (e) => {
        if (touchStartY.current === null) return;

        const deltaY = e.changedTouches[0].clientY - touchStartY.current
        const deltaTime = Date.now() - touchStartTime.current
        const velocity = deltaY / deltaTime

        const SWIPE_THRESHOLD = 80
        const VELOCITY_THRESHOLD = 0.4

        if (deltaY > SWIPE_THRESHOLD || velocity > VELOCITY_THRESHOLD) {
            dismissWithAnimation()
        } else {
            // Snap về vị trí cũ
            setDragY(0)
        }

        touchStartY.current = null
    }

    // Style áp lên wrapper bên trong drawer
    const drawerContentStyle = {
        transform: isDismissing
            ? 'translateY(100%)'           // animation tắt: trượt xuống hết
            : `translateY(${dragY}px)`,    // đang kéo: theo ngón tay
        transition: isDismissing
            ? 'transform 0.3s cubic-bezier(0.32, 0, 0.67, 0)'   // ease-out nhanh
            : dragY === 0
                ? 'transform 0.2s ease'    // snap về
                : 'none',                  // đang kéo: không có transition
        willChange: 'transform',
    }

    return (
        <Drawer
            className="prefix-drawer-dialog rounded-t-2xl"
            styles={{
                body: {padding: '12px'},
                // body: {padding: 6},
                content: {
                    minHeight: '50vh',
                    maxHeight: '77vh',
                    overflowY: 'auto',
                    // Ẩn overflow để không thấy content bị kéo ra ngoài
                    overflowX: 'hidden',
                    ...drawerContentStyle
                }
            }}
            placement={placement}
            closable={false}
            onClose={onClose}
            open={isToggle}
            key={placement}
            height={height}
            // Tắt animation mặc định của antd để tự handle
            motion={{
                motionName: '',
                motionAppear: false,
                motionEnter: false,
                motionLeave: false,
            }}
            title={
                <div className="flex flex-center">
                    <div
                        style={{
                            touchAction: 'none',
                            width: '30%',
                            height: 6,
                            background: '#d1d5db',
                            padding: '3px 0',
                        }}
                        className="rounded-full cursor-grab"
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                        onTouchEnd={handleTouchEnd}
                        onClick={onToggleHeight}
                    />
                    {title && title}
                </div>
            }
            footer={
                <div
                    onClick={onClose}
                    className="w-full text-center py-3 font-semibold text-xs uppercase text-slate-400 border-t cursor-pointer active:bg-gray-100">
                    {t('close')}
                </div>
            }>
            {/* Wrapper nhận transform thay vì drawer gốc */}
            <div ref={drawerBodyRef}>
                {children(isToggle, toggle)}
            </div>
        </Drawer>
    )
}

export default DrawerBottomDialog
